const i = "Melding", n = "Belangrijke melding", t = "Kennisgeving sluiten", o = {
  notification: i,
  criticalNotification: n,
  close: t
};
export {
  t as close,
  n as criticalNotification,
  o as default,
  i as notification
};
